import BioIcon from "../assets/icons/bio.svg";
import AddressIcon from "../assets/icons/address.svg";
import EducationIcon from "../assets/icons/school.svg";
import JobIcon from "../assets/icons/job.svg";
import SalaryIcon from "../assets/icons/account_balance.svg";
import InsuranceIcon from "../assets/icons/local_police.svg";
import DocIcon from "../assets/icons/doc.svg";

/**
 * Review Request section navigation config
 */
export const REVIEW_REQUEST_SECTIONS = [
  { key: "personal", label: "Personal", icon: BioIcon },
  { key: "address", label: "Address", icon: AddressIcon },
  { key: "education", label: "Education", icon: EducationIcon },
  { key: "employment", label: "Employment", icon: JobIcon },
  { key: "bank", label: "Bank", icon: SalaryIcon },
  { key: "insurance", label: "Insurance", icon: InsuranceIcon },
  { key: "declarations", label: "Declarations", icon: DocIcon },
  { key: "jobDetails", label: "Job Details", icon: JobIcon },
];

/** Sections that participate in flagging / review corrections */
export const REVIEW_FLAGGABLE_SECTIONS = REVIEW_REQUEST_SECTIONS.filter(
  (section) => section.key !== "jobDetails",
).map((section) => section.key);
